const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDankort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0722979,0,0,0.0722979,17.807,10.0964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8,30.3C-131.4,30.3 -241.3,140.2 -241.3,275.2C-241.3,410.2 -131.4,520.2 3.8,520.2L333.7,520.2C468.7,520.2 578.8,410.3 578.8,275.1C578.8,140.1 468.9,30 333.7,30L3.8,30L3.8,30.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8,525.3L3.8,525.3C-134,525.3 -246.3,413.2 -246.3,275.2C-246.3,137.4 -134.2,25.3 3.8,25.3L333.7,25.3C471.5,25.3 583.6,137.4 583.6,275.2C583.7,413.1 471.6,525.3 333.8,525.3M3.8,30.3C-131.4,30.3 -241.3,140.2 -241.3,275.2C-241.3,410.2 -131.4,520.2 3.8,520.2L333.7,520.2C468.7,520.2 578.8,410.3 578.8,275.1C578.8,140.1 468.9,30 333.7,30L3.8,30L3.8,30.3Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,260.3L501.1,390.9C523.9,358.1 537.1,318.3 537.1,275.3C537.1,230.1 522.3,188.2 497.1,154.4L391.4,260.3Z",
    style: {
      fill: "rgb(227,31,40)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,143.2C162.3,143.2 224.1,164.1 230.5,233.1L316.7,143.2L488.5,143.2C451,99.4 395.7,71.6 333.8,71.6L3.8,71.6C-58.1,71.6 -113.7,99.4 -150.9,143.2L80.4,143.2Z",
    style: {
      fill: "rgb(227,31,40)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.5,230.3L-83.8,310.7L34.3,310.7C69.1,310.7 79.8,296.2 87.6,268.4C95.4,240.8 75.9,230.3 52.1,230.3L-54.5,230.3Z",
    style: {
      fill: "rgb(227,31,40)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.5,401.8L226.3,286.6C209.4,365.2 154.2,401.8 50.7,401.8L-155.6,401.8C-118.3,448.7 -60.7,478.7 3.8,478.7L333.7,478.7C398.2,478.7 455.6,448.5 492.9,401.8L317.5,401.8Z",
    style: {
      fill: "rgb(227,31,40)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.bbd7a44d959e625ca697f322afba7a31.svg";
export { ForwardRef as ReactComponent };